import vindrApi from "../utils/vindrapi";
import { 
	Warning, 
	CircleNotch, 
	Check,
}								from "@phosphor-icons/react";


class Tool {

	hiddenItems	= [];
	stylingPanels = [];

	constructor(p) {
		if(p)
			this.tc = p;
	}
	init(){
		this.allHidden = this.tc.infoLayers.current ? !this.tc.infoLayers.current.getNode(this.infolayerId).data.defaultChecked : false;
		this.getHiddenItems();
	}
	exit(){
		this.closeStylingPanels();
	}
	setEventHandlers(){
		this.tc.map.on('layer.toggle', this.handleLayerToggle);
	}
	removeEventHandlers(){
		this.tc.map.off('layer.toggle', this.handleLayerToggle);
	}
	
	getPointFeatures(e){
		return this.parent.map.queryRenderedFeatures(e.point, {layers:[this.getToolLayer().layerId]});
	}
	
	getData = () => {
		
		return this.tc.map.getSource(this.getToolLayer().sourceId)?.serialize()?.data;
		
	}
	
	setData = (data) => {
		this.tc.map.getSource(this.getToolLayer().sourceId).setData(data);
	}
	deleteFeature = (id, item_id, cond) => {
		
		
		item_id = !Array.isArray(item_id) ? [item_id] : item_id;
		const data = this.getData();
		if(!data)
			return;
		for (let i = data.features.length - 1; i >= 0; i--) {
			if (item_id.includes(data.features[i].properties[id]) && (!cond || cond(data.features[i])))
				data.features.splice(i, 1);
		}
		
		this.setData(data);
	}
	addFeature = (f) => {
		
		f = !Array.isArray(f) ? [f] : f;
		const data = this.getData();
		if(!data)
			data = {};
		f.forEach((ft)=>{
			data.features.push(ft);
		});
		
		this.setData(data);
	}
	save(promise) {
		const { setters } = this.tc.draw.context;
		setters.setSaveState('saving');
		return promise
			.then((res)  => { 
				
				this.tc.checkOutdated(res);
				setters.setSaveState('finished'); 
				return res; 
			})
			.catch(err => { setters.setSaveState('error');    throw err; });
	}
	
	saveSetting = (tool, value)=>{
		
		const {getters} = this.parent.draw.context;
		
		var user = getters.user;
		
		if(user && user.userDetails && user.settings){
			
			
			
			if(!user.settings.tools){
				user.settings.tools = {};
			}
			if(!user.settings.tools[tool]){
				user.settings.tools[tool] = {};
			}
			user.settings.tools[tool] = {
				...user.settings.tools[tool],
				...value
			}

			vindrApi.updateSettings(user);
		}
		
	}
	getHiddenItems(){
		
		this.hiddenItems = this.tc.scenario[this.itemsName].filter((a)=>{return a.invisible ?? a?.properties?.invisible}).map((a)=>{return a[this.id] ?? a.properties[this.id]});
		
	}
	handleLayerToggle = (e) => {
		if(e.layerId == this.infolayerId)
			this.handleHideAllItems();
	}
	
	handleHideAllItems(){
		if(!this.areAllHidden()){
			this.hiddenItems = this.tc.scenario[this.itemsName].map((t, idx)=>{
				this.toggleItem(t[this.id] ?? t.properties[this.id], true, true);
				return t[this.id] ?? t.properties[this.id];
			});
		}
		else{
			const copy = this.hiddenItems.slice(0);
			copy.forEach((t)=>{this.toggleItem(t, false, true);});
			
		}
	}
	handleToggleItem = (e, item_id, f, dontRefresh)=>{
		e.stopPropagation();
		this.toggleItem(item_id, f, dontRefresh);
	}
	areAllHidden(){
		return this.hiddenItems.length == this.tc.scenario[this.itemsName].length;
	}
		
	toggleItem(item_id, f, dontRefresh, extra){
		
		const force = typeof f == "boolean" ? f : 'undefined';
		const hide = document.querySelector("#bndr_"+item_id)?.classList?.toggle("opacity-25", typeof force == "boolean" ? force : undefined);
		
		
		if(!hide)
			this.tc.infoLayers.current.forceVisibility(this.infolayerId, true);
		
		this.tc.map.setFeatureState({
            source: this.getToolLayer().sourceId,
            id: item_id
        }, {invisible:(force != 'undefined' ? force : hide)});
		
		
		if(!hide){
			const index = this.hiddenItems.indexOf(item_id);
			if (index > -1) {
			  this.hiddenItems.splice(index, 1);
			}
		}
		else
			this.hiddenItems.push(item_id);
		
		
		if(this.areAllHidden())
			this.allHidden = true;
		else
			this.allHidden = false;
		
			
		
		this.updateScenarioFeatPop(this.id, item_id, {invisible: (force != 'undefined' ? force : hide)});
		this.updateMapFeatPop(this.id, item_id, {invisible: (force != 'undefined' ? force : hide)});
		this.tc.infoLayers.current.updateLayerData(this.infolayerId);
		
		this.tc.infoLayers.current.forceVisibility(this.infolayerId, !this.allHidden);	
		
		if(extra)
			extra(item_id, force, hide);

		
	}
	updateMapFeatCoordinates(item_id, coordinates, cond){
		const data = this.getData();
		if(!data)
			return;
		
		for (let i = data.features.length - 1; i >= 0; i--) {
			if ((data.features[i].properties[this.id] == item_id || data.features[i].properties.tempid == item_id) && (!cond || cond(data.features[i])))
				data.features[i].geometry.coordinates = coordinates;
		}
		
		this.setData(data);
	}
	updateMapFeatPop(id, item_id, properties, cond){
		const data = this.getData();
		if(!data)
			return;
		for (let i = data.features.length - 1; i >= 0; i--) {
			if ((data.features[i].properties[id] == item_id || data.features[i].properties.tempid == item_id) && (!cond || cond(data.features[i])))
				data.features[i].properties = {
					...data.features[i].properties,
					...properties
				};
		}
		
		this.setData(data);
	}
	updateScenarioFeatPop(id, item_id, properties){
		
		const s = structuredClone(this.tc.scenario);
		const oldDrawing = s[this.itemsName].find((p)=>{return p[id] == item_id || (p.properties && p?.properties[id] == item_id)});
		
		oldDrawing.properties = {
			...oldDrawing.properties,
			...properties
		}
		this.tc.scenario = s;
		this.tc.setScenario(s);
	}
	
	updateScenarioItemId(id, oldId, newId){
		
		const s = structuredClone(this.tc.scenario);
		const old = s[this.itemsName].find((p)=>{return p[id] == oldId || (p.properties && p?.properties[id] == oldId)});
		
		old[id] = newId;
		old.properties[id] = newId;
		
		
		this.tc.scenario = s;
		this.tc.setScenario(s);
	}
	
	resetLayer = ()=>{
		this.tc.infoLayers.current.resetSystemLayer(this.infolayerId);
		
	}
	
	refreshMap(){
		const data = this.tc.map.getSource(this.getToolLayer().sourceId)._options.data;
		this.tc.map.getSource(this.getToolLayer().sourceId).setData(data);
	}
	
	display = ()=>{
		
		if(this.silent)
			return;
		if(this.tc.serviceBar.current && (this.tc.handler && this.tc.handler.constructor.name == this.constructor.name))
			this.tabIndex =	this.tc.serviceBar.current.inject(this.render(), this.tabIndex);
	}
	setupStreamer = (type) => {
		if(this.silent)
			return;
		// create stream
		this.stream = vindrApi.requestCalcProgress(
			type,
			this.tc.scenario.projectid,
			this.tc.scenario.scenario_id
		);

		this.stream.on("processing", data => {
			try {
				const json = JSON.parse(data);
				this.updateState(json);
			} catch {
				this.handleError();
			}
		});

		this.stream.on("completed", data => {
			try {
				const json = JSON.parse(data);
				this.updateState(json);
			} catch {
				this.handleError();
			}
		});

		this.stream.on("error", err => {
			this.stream.close();
			try {
				this.statusText = false;
			} catch(error) {
				this.handleError(error);
			}
		});

		this.stream.on("message", message => {
			try {
				const json = JSON.parse(message);
				this.updateState(json);
			} catch(error) {
				this.handleError(error);
			}
		});
	}

	updateState = (json) => {
		
		this.statusText = json.message;

		switch (this.getStreamerState(json)) {
			case 'processing':
			case 'queued':	
				this.statusRecalculate = false;
				this.statusText = this.formatRemainingTime(json);
				this.statusIcon = <CircleNotch className="spin" size={16} />;
				break;
			case 'completed':
				this.handleDoneCalc();
				this.statusRecalculate = false;
				this.statusIcon = <Check color="green" size={16} />;
				this.stream.close()
				this.hideMsg();
				break;
			case 'error':
				//this.hideMsg();
				this.statusRecalculate = true;
				this.stream.close();
				this.statusText = 'Calculation failed';
				this.statusIcon = <Warning color="red" size={16} />;
				break;
			case 'not_found':
				this.statusText = false;
				this.statusRecalculate = true;
				this.stream.close();
				this.statusIcon = <Warning color="red" size={16} />;
				break;
			default:
				this.statusIcon = false;
		}
		this.display();
	}
	
	hideMsg = () => {
		setTimeout(()=>{
			this.statusCompleted = true;
			this.statusText = false;
			this.display();
		}, 2000)
	}
	
	handleError = (error) => {
		console.log(error);
		this.statusText = "Error";
		this.statusIcon = <Warning color="red" size={16} />;
		this.display();
	}
	
	formatRemainingTime = ({ estimated_seconds, estimated_minutes }) => {
		if (estimated_minutes >= 1) {
			const minutes = Math.floor(estimated_minutes);
			const seconds = Math.round((estimated_minutes - minutes) * 60);

			if (minutes === 1 && seconds === 0) {
				return 'About 1 minute remaining';
			}

			if (minutes >= 1 && seconds > 0) {
				return `About ${minutes} minute${minutes > 1 ? 's' : ''} and ${seconds} second${seconds > 1 ? 's' : ''} remaining`;
			}

			return `About ${minutes} minute${minutes > 1 ? 's' : ''} remaining`;
		}
		
		if (estimated_seconds < 60) {
			return estimated_seconds <= 5
				? 'Almost done'
				: `About ${estimated_seconds} seconds remaining`;
		}

		return 'Calculating remaining time...';
	}
}
export default Tool;